<template>
  <div class="pt-2 secondary">
    <div class="text-h6 text-center mb-2">{{ groupName }} | {{ itemName }}</div>

    <v-text-field
      label="Title"
      color="primary"
      dense
      outlined
      hide-details
      dark
      class="mb-2"
    ></v-text-field>

    <v-textarea
      dense
      outlined
      hide-details
      dark
      color="primary"
      class="mb-4"
      no-resize
      label="Description"
    ></v-textarea>

    <v-file-input
      outlined
      dense
      prepend-inner-icon="mdi-camera"
      prepend-icon=""
      multiple
      accept="image/png, image/jpeg, image/jpg"
      :clearable="false"
      v-model="photos"
      @change="onChange"
      :placeholder="`${photosPreviews.length} Εικόν${
        photosPreviews.length == 1 ? 'α' : 'ες'
      }`"
      persistent-hint
      ref="photos"
      class="mb-1"
      id="photoInput"
      v-show="false"
    >
    </v-file-input>

    <v-row class="mb-5">
      <v-col cols="2">
        <div class="file-wrapper rounded">
          <label
            class="
              d-flex
              flex-column
              align-center
              justify-center
              add-file
              primary
              pa-2
              rounded
            "
            for="photoInput"
          >
            <v-icon color="white" class="mb-2">mdi-plus</v-icon>
            <div class="body-2 white--text text-center">Add Photos</div>
          </label>
        </div>
      </v-col>

      <v-col cols="2" v-for="(photo, index) in photosPreviews" :key="index">
        <div class="file-wrapper rounded">
          <div
            class="
              file-overlay
              d-flex
              flex-column
              align-center
              justify-center
              rounded
            "
          >
            <div class="caption font-weight-bold white--text text-center">
              {{ photo.name }}
            </div>

            <v-btn icon small color="error" @click="deletePhoto(photo)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>

          <img :src="photo.preview" class="rounded" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["groupName", "itemName"],
  data() {
    return {
      photos: [],
      allPhotos: [],
    };
  },
  computed: {
    photosPreviews() {
      return [
        ...this.allPhotos.map((photo) => {
          const size = photo.size / 1024 / 1024;
          const roundedSize = Math.round((size + Number.EPSILON) * 100) / 100;

          return {
            photo,
            size: roundedSize,
            name: photo.name,
            preview: URL.createObjectURL(photo),
          };
        }),
      ];
    },
  },
  methods: {
    onChange() {
      this.photos.forEach((photo) => {
        const found = this.allPhotos.find((p) => p.name == photo.name);

        if (!found) this.allPhotos.push(photo);
      });

      this.photos = [];
    },
    deletePhoto(photoObject) {
      this.$delete(this.allPhotos, this.allPhotos.indexOf(photoObject.photo));

      if (this.allPhotos.length == 0) this.$refs.photos.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
.file-wrapper {
  padding-bottom: 100%;
  position: relative;

  .file-overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(#000, 0.4);
    z-index: 1;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  .add-file {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    cursor: pointer;
  }
}
</style>